import moment from "moment";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import {
  TOAST_DURATION,
  TOAST_ERROR_COLOR,
  TOAST_POSITION,
  TOAST_SUCCESS_COLOR,
} from "../../../../common/app_constant";
import {
  ENV,
  s3_bucket_prod_url,
  s3_bucket_uat_url,
  SUB_DIRECTORY,
} from "../../../../common/constant";
// import Blog from "../../../../component/blog";
import Newsletter from "../../../../component/newsletter";
import OurApp from "../../../../component/our_app";
import RecommendedPolicy from "../../../../component/recommended_policy";
import {
  actionDownload,
  resetDownloadPolicyResponse,
} from "../dashboard/store";
import {
  actionPolicyWallet,
  actionPolicyWalletDelete,
  resetPolicyWalletDeleteResponse,
  resetPolicyWalletResponse,
} from "./store";
import { useRef } from "react";
import Loader from "../../../../component/page_loader";
import InfromationCard from "../../../../component/information_card";
import Contact from "../../../../component/contact";
import PolicyList from "../policy_wallet/dropdown.json";

const PolicyWallet = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { policyWallet, deletePolicyWallet } = useSelector(state => ({
    ...state.policyWalletStore,
  }));

  const { downloadPolicy } = useSelector(state => ({
    ...state.dashboardStore,
  }));

  const {
    register,
    formState: { errors },
    handleSubmit,
    getValues,
    setValue,
    watch,
    control,
  } = useForm({
    defaultValues: {
      is_active: false,
    },
  });

  const [leadPolicy, setLeadPolicy] = useState([]);
  const [filteredLeadPolicy, setFilteredLeadPolicy] = useState([]);
  const [allPolicyData, setAllPolicyData] = useState([]);
  const [selectedItem, setSelectedItem] = useState("A");
  const [isActive, setIsActive] = useState([]);
  const [isInActive, setIsInActive] = useState([]);
  const [filterArr, setFilterArr] = useState([]);
  const [searchPolicy, setSearchPolicy] = useState("");

  const [clicked, setClicked] = useState("0");

  const contentEl = useRef();
  const [isLoader, setLoader] = useState(true);

  const handleToggle = index => {
    if (clicked === index) {
      return setClicked("0");
    }
    setClicked(index);
  };

  useEffect(() => {
    // if (getValues('is_active') === false) {
    //   setValue('is_active', true)
    dispatch(actionPolicyWallet());
    // }

    // setLoader(false)
    setClicked(null);
    setSelectedItem("A");
    var isActive = filteredLeadPolicy;
    setLeadPolicy(isActive);
    setFilterArr(isActive);
  }, []);

  const getPolicyNameById = policyId => {
    const policy = PolicyList?.policy_list?.find(
      p => Number(p.id) == Number(policyId)
    );
    return policy ? policy.name : "-";
  };
  const getInsurerNameById = insurerId => {
    const policy = PolicyList?.insurer_list?.find(
      p => Number(p.id) == Number(insurerId)
    );
    return policy ? policy.insurer_name : "-";
  };
  useEffect(() => {
    if (policyWallet !== null) {
      dispatch(resetPolicyWalletResponse());
      if (policyWallet.status === true) {
        setLoader(false);
        var isActive = policyWallet.data.rows;
        var isInactive = policyWallet.data.rows;
        setLeadPolicy(isActive);
        setAllPolicyData(policyWallet.data.rows);
        setIsActive(isActive);
        setIsInActive(isInactive);
        setFilterArr(isActive);
        setFilteredLeadPolicy(isActive);
      } else {
        setLoader(false);
        switch (policyWallet.status_code) {
          case 401:
            localStorage.clear();
            navigate("/login", { replace: true });
            break;
          default:
        }
      }
    }
  }, [policyWallet]);

  useEffect(() => {
    if (deletePolicyWallet !== null) {
      dispatch(resetPolicyWalletDeleteResponse());
      if (deletePolicyWallet.result === true) {
        toast.success(deletePolicyWallet.message, {
          duration: TOAST_DURATION,
          position: TOAST_POSITION,
          style: {
            color: TOAST_SUCCESS_COLOR,
          },
        });
        dispatch(actionPolicyWallet());
      } else {
        switch (deletePolicyWallet.status) {
          case 400:
            toast.error(deletePolicyWallet.message, {
              duration: TOAST_DURATION,
              position: TOAST_POSITION,
              style: {
                color: TOAST_ERROR_COLOR,
              },
            });
            localStorage.clear();
            navigate("/login", { replace: true });
          default:
        }
      }
    }
  }, [deletePolicyWallet]);

  useEffect(() => {
    if (downloadPolicy !== null) {
      dispatch(resetDownloadPolicyResponse());
      if (downloadPolicy.status === true) {
        window.open(downloadPolicy.data.url);
      } else {
        switch (downloadPolicy.status_code) {
          case 400:
            toast.error(downloadPolicy.message, {
              duration: TOAST_DURATION,
              position: TOAST_POSITION,
              style: {
                color: TOAST_ERROR_COLOR,
              },
            });
            localStorage.clear();
            navigate("/login");
            break;
          case 401:
            localStorage.clear();
            navigate("/login", { replace: true });
            break;
          default:
        }
      }
    }
  }, [downloadPolicy]);

  const renderProgressBar = item => {
    var date1 = moment(new Date()).format("YYYY-MM-DD");
    var date2 = moment(item?.expiring_date);
    var days = date2.diff(date1, "days");

    return (
      <>
        <p class="fw-600 mb-0">{days} Days left</p>
        <div class="progress">
          <div
            class="progress-bar"
            role="progressbar"
            style={{ width: `${days}%` }}
            aria-valuenow="135"
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
      </>
    );
  };

  const renderDocuments = item => {
    var arrDoc = [];

    item != null && item.length > 0
      ? item.map((item, index) => {
        arrDoc.push(
          <div className="col-md-6 mb-2">
            <div className="card">
              <div className="card-body d-flex justify-content-between">
                <div className="col-10">
                  <p className="mb-0">{item?.actual_uploaded_file_name}</p>
                  {/* <small>{item.created_at}</small> */}
                </div>
                <div className="col-2 text-center">
                  <i
                    className="fa fa-download cursor-pointer"
                    onClick={e => {
                      e.preventDefault();
                      dispatch(actionDownload({ dmsIds: [item?.id] }));
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        );
      })
      : arrDoc.push(
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">No Documents Uploaded</div>
          </div>
        </div>
      );

    return arrDoc;
  };
  const renderPolicy = () => {
    var policyArr = [];

    filteredLeadPolicy != null && filteredLeadPolicy.length > 0
      ? filteredLeadPolicy.map((item, index) => {
        policyArr.push(
          <div className="accordion">
            <div className="col-12 mt-3 position-relative">
              <div className="card border-0 policy-card">
                <div className="card-header d-flex">
                  <div
                    className="col-10"
                    onClick={() => {
                      handleToggle(index);
                    }}
                  >
                    <div
                      className={`accordion_item ${clicked === index ? "active" : ""
                        }`}
                    >
                      <div className="row">
                        <div className="col-6">
                          <span className="ms-auto fw-600 card-title">
                            {/* {item.insurer_name} */}
                            {getInsurerNameById(Number(item.insurer_id))}
                          </span>
                        </div>
                        <div className="col-6 text-end">
                          <div className="d-flex justify-content-end">
                            <label className="card-label">Policy No.:</label>
                            <p className="card-value mb-0">
                              {" "}
                              {item.policy_no}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <button className="btn btn-sm text-primary ms-auto me-4 btn-hover"
                    onClick={() => {
                      Swal.fire({
                        title: 'Are you sure?',
                        text: "Are you sure you want to delete policy and corresponding documents?",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonText: 'Yes, delete it!',
                        customClass: {
                          confirmButton: 'btn btn-primary',
                          cancelButton: 'btn btn-danger ms-1 margin-left'
                        },
                        buttonsStyling: false

                      }).then(function (result) {
                        if (result.value) {
                          dispatch(actionPolicyWalletDelete({ id: item.id }))

                        }
                      })

                    }}
                  >
                    <i className="fa fa-trash" />
                  </button>           */}
                </div>
                <div className="card-body pointer">
                  <div className="row">
                    <div className="col-12 col-md-4">
                      {/* <img
                          src={item.insurer_company_logo}
                          className="w-75"
                          alt=""
                        /> */}
                      <label className="card-label">Insured Name:</label>
                      <p className="card-value mb-0"> {item.insured_name}</p>
                    </div>
                    <div className="col-4">
                      <label className="card-label">
                        Expected Premium.:
                      </label>
                      <p className="card-value mb-0"> {item.premium} </p>
                    </div>
                    <div className="col-4">
                      <label className="card-label">Policy Type</label>
                      <p className="card-value mb-0">
                        {getPolicyNameById(Number(item.policy_type_id))}
                      </p>
                    </div>

                    <div className="col-4 mt-2">
                      <label className="card-label">Start Date:</label>
                      <p className="card-value mb-0">
                        {moment(item.start_date).format("DD/MM/YYYY")}
                      </p>
                    </div>
                    <div className="col-4 mt-2">
                      <label className="card-label">End Date:</label>
                      <p className="card-value mb-0">
                        {moment(item.expiring_date).format("DD/MM/YYYY")}
                      </p>
                    </div>
                    <div className="col-4 mt-2">
                      <label className="card-label">Remark</label>
                      <p className="card-value mb-0"> {item.remark} </p>
                    </div>

                    {/* <div class="col-12 col-md-2 text-start">
                        <label class="card-label text-primary fw-600">
                          Renewal Status:
                        </label>
                        {item.renewal_status === "active" ? (
                          renderProgressBar(item)
                        ) : (
                          <p className="fw-600 mb-0 badge bg-danger rounded">
                            Expired
                          </p>
                        )}
                      </div> */}

                    <div
                      ref={contentEl}
                      className="col-12"
                      hidden={clicked === index ? false : true}
                    // style={
                    //   clicked === index
                    //     ? { height: contentEl.current.scrollHeight }
                    //     : { height: "0px" }
                    // }
                    >
                      <div className="row mt-3 bg-light py-3 rounded fs-7 ">
                        <div className="col-12 mt-3 mt-md-0">
                          <h6>Documents({item.documents?.length})</h6>
                        </div>
                        {renderDocuments(item.documents)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <img alt="ribbon" className="ribbon" src="images/ribbon.png" /> */}
            </div>
          </div>
        );
      })
      : policyArr.push(
        <div className="d-flex justify-content-center align-items-center mt-5">
          <h5>No Policies To Display</h5>
        </div>
      );
    return policyArr;
  };

  return (
    <>
      <div className="row mt-1">
        <div className="col-12">
          <nav
            className="--bs-breadcrumb-divider: '>';"
            aria-label="breadcrumb"
          >
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a
                  onClick={() => {
                    // navigate("/dashboard");
                  }}
                >
                  Dashboard
                </a>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                Policy Wallet
              </li>
            </ol>
          </nav>
        </div>
        <div className="col-12 col-md-9">
          <div className="row">
            <div className="col-12">
              <div className="row px-2">
                <div class="card profile-section col-md-10">
                  <div class="card-body">
                    <form>
                      <div class="form-group has-search">
                        <span class="fa fa-search form-control-feedback"></span>
                        <input
                          type="text"
                          name="search"
                          class="form-control"
                          placeholder={"Search Policy"}
                          value={searchPolicy}
                          // onChange={(event) => {
                          //   setSearchPolicy(event.target.value)
                          //   var arrFilterPolicyWallet = Object.assign([], leadPolicy);
                          //   if (event.target.value?.length > 0) {
                          //     setSearchPolicy(event.target.value)
                          //     var arrFilterPolicyWallet = arrFilterPolicyWallet.filter(
                          //       (item) =>
                          //         item.policy_no.toLowerCase().includes(event.target.value.toLowerCase()) ||
                          //         item.insurer_name.toLowerCase().includes(`${event.target.value.toLowerCase()}`)
                          //     );
                          //     setFilteredLeadPolicy(arrFilterPolicyWallet)
                          //   } else {
                          //     setSearchPolicy(event.target.value)
                          //     setFilteredLeadPolicy(arrFilterPolicyWallet)

                          //   }
                          // }}

                          onChange={event => {
                            setSearchPolicy(event.target.value);
                            var arrFilterPolicyWallet = Object.assign(
                              [],
                              leadPolicy
                            );
                            if (event.target.value?.length > 0) {
                              var arrFilterPolicyWallet =
                                arrFilterPolicyWallet.filter(
                                  item =>
                                    (item.policy_no &&
                                      item.policy_no
                                        .toLowerCase()
                                        .includes(
                                          event.target.value.toLowerCase()
                                        )) ||
                                    (item.insurer_name &&
                                      item.insurer_name
                                        .toLowerCase()
                                        .includes(
                                          event.target.value.toLowerCase()
                                        )) ||
                                    (item.insured_name &&
                                      item.insured_name
                                        .toLowerCase()
                                        .includes(
                                          event.target.value.toLowerCase()
                                        )) ||
                                    (item.policy_type &&
                                      item.policy_type
                                        .toLowerCase()
                                        .includes(
                                          event.target.value.toLowerCase()
                                        ))
                                );
                              setFilteredLeadPolicy(arrFilterPolicyWallet);
                            } else {
                              setFilteredLeadPolicy(arrFilterPolicyWallet);
                            }
                          }}
                        />
                      </div>
                    </form>
                  </div>
                </div>
                <div class="col-md-2 my-auto">
                  <button
                    class="btn btn-primary btn-sm"
                    onClick={() => {
                      navigate("/policy-wallet/add-policy-wallet");
                    }}
                  >
                    Add Policy
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div>
            {/*START: Tab */}
            <div className="mt-4 row justify-content-between tab-menu">
              <div className="col-12 col-md-8">
                <button
                  className={`btn btn-light btn-sm ${selectedItem === "A" ? "active" : ""
                    }`}
                  onClick={() => {
                    setClicked(null);
                    setSelectedItem("A");
                    var isActive = filteredLeadPolicy;
                    setLeadPolicy(isActive);
                    setFilterArr(isActive);
                  }}
                >
                  All Policy Wallet ({filteredLeadPolicy?.length})
                </button>
                {/* <button
                  className={`btn btn-light btn-sm ${selectedItem === "I" ? 'active' : ''}`}
                  style={{
                    marginLeft: 14,
                  }}
                  onClick={() => {
                    setClicked(null);
                    setSelectedItem("I")
                    var isInactive = allPolicyData.filter((item) => { return item.renewal_status === 'expire' })
                    setLeadPolicy(isInactive)
                    setFilterArr(isInactive)
                  }}
                >
                  Expired ({isInActive.length})
                </button> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-9">
          {isLoader === true ? (
            <Loader />
          ) : (
            <div className="row mt-2">{renderPolicy()}</div>
          )}
        </div>
        <div className="col-12 col-md-3">
          <InfromationCard isMarginTop={false} />
          {/* <Blog /> */}
          {/* <OurApp /> */}
          <Contact />
        </div>
      </div>
    </>
  );
};

export default PolicyWallet;
